import { render, staticRenderFns } from "./CulturaCadastroModal.vue?vue&type=template&id=2a5507ee&scoped=true"
import script from "./CulturaCadastroModal.vue?vue&type=script&lang=js"
export * from "./CulturaCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./CulturaCadastroModal.vue?vue&type=style&index=0&id=2a5507ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5507ee",
  null
  
)

export default component.exports